import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { hotList } from '@/mocks/home';

export default function HotListSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    checkScroll();
    el.addEventListener('scroll', checkScroll, { passive: true });
    return () => el.removeEventListener('scroll', checkScroll);
  }, []);

  const scroll = (direction: 'left' | 'right') => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({ left: direction === 'left' ? -340 : 340, behavior: 'smooth' });
  };

  return (
    <section className="bg-background-950 py-14 md:py-20" aria-label="吃瓜热榜">
      <div className="px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 max-w-7xl mx-auto">
          <div>
            <span className="inline-block px-4 py-1 rounded-full border border-background-50/20 text-background-50/60 text-xs mb-3">
              24H 不打烊
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">
              吃瓜热榜实时滚动
            </h2>
            <p className="mt-2 text-background-50/40 text-sm">
              全网最热爆料，每分钟都在更新
            </p>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/20 text-background-50 hover:border-background-50/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/20 text-background-50 hover:border-background-50/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto pb-4 scroll-smooth snap-x snap-mandatory max-w-7xl mx-auto"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {hotList.map((item, index) => (
            <Link
              key={item.id}
              to={`/article/${item.slug}`}
              className="flex-shrink-0 w-[280px] md:w-[320px] snap-start group cursor-pointer"
            >
              <div className="bg-background-50 rounded-lg overflow-hidden transition-transform duration-300 group-hover:-translate-y-1">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                      #{index + 1}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className="px-2.5 py-0.5 rounded-full bg-background-950/70 text-accent-400 text-xs font-medium">
                      {item.category}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-foreground-900 font-semibold text-sm leading-snug line-clamp-2 mb-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-accent-500"></i>
                      {item.hotScore}热度
                    </span>
                    <span>{item.time}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}